{
  "cc-migrations-tooling.confluence-agents-spotlights.done": [
    {
      "type": 0,
      "value": "Got it"
    }
  ],
  "cc-migrations-tooling.confluence-agents-spotlights.next": [
    {
      "type": 0,
      "value": "Next"
    }
  ],
  "cc-migrations-tooling.confluence-agents-spotlights.step-count": [
    {
      "type": 1,
      "value": "currentStep"
    },
    {
      "type": 0,
      "value": " of "
    },
    {
      "type": 1,
      "value": "totalSteps"
    }
  ],
  "cc-migrations-tooling.confluence-agents-spotlights.step-one.body": [
    {
      "type": 0,
      "value": "Try a sample prompt to see how agents pull together statuses and updates for you."
    }
  ],
  "cc-migrations-tooling.confluence-agents-spotlights.step-one.title": [
    {
      "type": 0,
      "value": "See what agents can do"
    }
  ],
  "cc-migrations-tooling.confluence-agents-spotlights.step-two.body": [
    {
      "type": 0,
      "value": "Use this dropdown to chat with another agent or switch back to Rovo."
    }
  ],
  "cc-migrations-tooling.confluence-agents-spotlights.step-two.title": [
    {
      "type": 0,
      "value": "Switch agents anytime"
    }
  ],
  "cc-migrations-tooling.confluence-agents-spotlights.story.agent-name": [
    {
      "type": 0,
      "value": "Dev Assistant"
    }
  ],
  "cc-migrations-tooling.confluence-agents-spotlights.story.prompt": [
    {
      "type": 0,
      "value": "What are best practices for software development?"
    }
  ]
}